export default "<app-terms-conditions></app-terms-conditions>\r\n";